import { useSearchParams } from 'react-router';
import { Carte } from '@journal/ui';
import { LienBouton } from '../components/LienBouton.tsx';

/**
 * « Votre espace est supprimé » — la page qui suit la suppression.
 *
 * ── Ce qu'elle remplace ─────────────────────────────────────────────────────
 * Après la suppression, la page se rechargeait sur un espace qui n'existait
 * plus, et le navigateur affichait le JSON brut « Espace client non résolu ».
 * Au moment exact où l'on vient de fermer son espace, et où l'on se demande si
 * c'était la bonne décision.
 *
 * Publique : les sessions viennent d'être fermées. Elle dit ce qui s'est
 * passé, jusqu'à quand c'est réversible, et comment revenir — se reconnecter,
 * ce qui mène à l'écran de réactivation.
 */
export function EspaceSupprime() {
  const [parametres] = useSearchParams();
  const le = parametres.get('le');
  const date = le && !Number.isNaN(new Date(le).getTime())
    ? new Date(le).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
    : null;

  return (
    <main id="contenu" className="mx-auto max-w-[38rem] px-5 py-16">
      <Carte titre="Votre espace est supprimé">
        <div className="flex flex-col gap-3 text-[14px] leading-relaxed">
          <p>
            {date
              ? <>Vos données seront <strong>définitivement effacées le {date}</strong>. D’ici là, elles sont intactes.</>
              : <>Vos données seront définitivement effacées dans 30 jours. D’ici là, elles sont intactes.</>}
          </p>
          <p>
            L’abonnement est résilié au terme de la période déjà payée : il ne
            sera plus prélevé ensuite.
          </p>
          <p>
            <strong>Si vous souhaitez réactiver l’espace, reconnectez-vous.</strong>
          </p>
          <p className="mt-1">
            <LienBouton vers="/">Se reconnecter</LienBouton>
          </p>
        </div>
      </Carte>
    </main>
  );
}
